import React from 'react';

const About = () => {
  return (
    <div 
      name="about" 
      className="w-full min-h-screen bg-gray flex justify-center items-center px-6 sm:px-12"
    >
      <div className="max-w-screen-lg flex flex-col justify-center">
        <div className="pb-8"> 
          <h1 className="text-4xl sm:text-5xl font-bold border-b-4 border-gray-500 py-4 text-center sm:text-center ">
            About
          </h1>
          <p className="text-gray-900 text-lg sm:text-2xl mt-6 text-center sm:text-center">
            Hi! I'm Jezreel Ortiz, a freelance Frontend Web Developer and eBay Listing Specialist with a strong passion for building clean, responsive, and user-focused digital experiences. With hands-on experience in modern web technologies, I create seamless web applications that merge functionality with thoughtful design.</p>
          
          <p className="text-gray-900 text-lg sm:text-2xl mt-6 text-center sm:text-center">
            Beyond development, I bring valuable skills in e-commerce—particularly in managing product listings, research, and optimization on eBay. I’ve handled everything from product sourcing and creating keyword-rich titles and descriptions to maintaining listing visibility and customer service. </p>

          <p className="text-xl sm:text-2xl mt-8 border-b-4 border-gray-500 py-4 text-center sm:text-center font-semibold">
            Check below for the tools I am proficient with!
          </p>
        </div>      
      </div>
    </div>
  );
};

export default About;
